var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _vm._l(_vm.checkingData, function (item, i) {
            return [
              item.checkingNum
                ? _c(
                    "v-flex",
                    {
                      key: i,
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md6: "",
                        lg6: "",
                        "pa-2": "",
                      },
                    },
                    [
                      _c("DataChecking", {
                        attrs: {
                          checkingMessage: item.checkingMessage,
                          checkingNum: item.checkingNum,
                          routerLink: item.routerLink,
                          checkingArr: item.checkingArr,
                        },
                        model: {
                          value: _vm.checkingModel,
                          callback: function ($$v) {
                            _vm.checkingModel = $$v
                          },
                          expression: "checkingModel",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("GuidelineCoFactor", {
        attrs: {
          CoFactorAnalyteMismatchedUnitGroups:
            _vm.CoFactorAnalyteMismatchedUnitGroups,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }